var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid px-3 py-3" }, [
    _vm._m(0),
    _c("div", { staticClass: "card shadow-sm mb-3" }, [
      _c("div", { staticClass: "card-body text-center" }, [
        _vm.imgSrc
          ? _c("div", { staticClass: "mb-3" }, [
              _c("img", {
                staticClass: "rounded",
                staticStyle: {
                  width: "140px",
                  height: "140px",
                  "object-fit": "cover",
                },
                attrs: { src: _vm.imgSrc, alt: "Performer photo" },
              }),
            ])
          : _vm._e(),
        _vm.performer.name
          ? _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.performer.name)),
            ])
          : _vm._e(),
        _vm.performer.performer_type
          ? _c("div", { staticClass: "text-muted" }, [
              _vm._v(" " + _vm._s(_vm.performer.performer_type) + " "),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm.performer.about
      ? _c("div", { staticClass: "card shadow-sm mb-3" }, [
          _c("div", { staticClass: "card-header fw-semibold" }, [
            _vm._v("About"),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.performer.about)),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.hasAnySocial
      ? _c("div", { staticClass: "card shadow-sm mb-3" }, [
          _c("div", { staticClass: "card-header fw-semibold" }, [
            _vm._v("Social"),
          ]),
          _c("div", { staticClass: "list-group list-group-flush" }, [
            _vm.performer.instagram
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.buildInstagramUrl(_vm.performer.instagram),
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _vm._m(1),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v("@" + _vm._s(_vm.trimAt(_vm.performer.instagram))),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
            _vm.performer.facebook
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.buildFacebookUrl(_vm.performer.facebook),
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _vm._m(2),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v(
                        _vm._s(_vm.compactFacebook(_vm.performer.facebook))
                      ),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
            _vm.performer.tiktok
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.buildTiktokUrl(_vm.performer.tiktok),
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _vm._m(3),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v("@" + _vm._s(_vm.trimAt(_vm.performer.tiktok))),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
            _vm.performer.dreamdj
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.performer.dreamdj,
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _vm._m(4),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v(
                        "@" +
                          _vm._s(
                            _vm.extractDreamDJArtist(_vm.performer.dreamdj)
                          )
                      ),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm.hasAnyTips
      ? _c("div", { staticClass: "card shadow-sm mb-4" }, [
          _c("div", { staticClass: "card-header fw-semibold" }, [
            _vm._v("Tip"),
          ]),
          _c("div", { staticClass: "list-group list-group-flush" }, [
            _vm.performer.cashapp
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.buildCashAppUrl(_vm.performer.cashapp),
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "input-group-text me-2 fw-bold" },
                      [_vm._v("$")]
                    ),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v(
                        "$" + _vm._s(_vm.trimDollar(_vm.performer.cashapp))
                      ),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
            _vm.performer.venmo
              ? _c(
                  "a",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: {
                      href: _vm.buildVenmoUrl(_vm.performer.venmo),
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "input-group-text me-2 fw-bold" },
                      [_vm._v("V")]
                    ),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v("@" + _vm._s(_vm.trimAt(_vm.performer.venmo))),
                    ]),
                    _c("i", { staticClass: "ph ph-arrow-up-right ms-2" }),
                  ]
                )
              : _vm._e(),
            _vm.performer.paypal
              ? _c(
                  "div",
                  {
                    staticClass:
                      "list-group-item list-group-item-action d-flex align-items-center",
                    attrs: { href: `mailto:${_vm.performer.paypal}` },
                  },
                  [
                    _vm._m(5),
                    _c("span", { staticClass: "flex-grow-1" }, [
                      _vm._v(_vm._s(_vm.performer.paypal)),
                    ]),
                    _c("i", { staticClass: "ph ph-envelope-simple ms-2" }),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "d-grid gap-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-dark btn-lg",
          on: { click: _vm.confirmAndReturn },
        },
        [_vm._v(" Looks good — Save this ")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-dark btn-lg",
          on: {
            click: function ($event) {
              return _vm.goBack()
            },
          },
        },
        [_vm._v(" Edit details ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
      _c("h5", { staticClass: "m-0" }, [_vm._v("Performer Preview")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text me-2" }, [
      _c("i", { staticClass: "ph-bold ph-instagram-logo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text me-2" }, [
      _c("i", { staticClass: "ph-bold ph-facebook-logo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text me-2" }, [
      _c("i", { staticClass: "ph-bold ph-tiktok-logo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text me-2" }, [
      _c("i", { staticClass: "ph-bold ph-tiktok-logo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-text me-2" }, [
      _c("i", { staticClass: "ph-bold ph-paypal-logo" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }